import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { authAPI } from '../../services/api';
import Logo from '../../components/Logo/Logo';
import '../Login/Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Ingresa tu correo electrónico');
      return;
    }

    try {
      setLoading(true);
      await authAPI.forgotPassword(email);
      setSent(true);
      toast.success('Listo. Revisa tu correo (y spam).');
    } catch (error) {
      // Do not reveal whether email exists
      console.error('Forgot password error:', error);
      setSent(true);
      toast.success('Listo. Revisa tu correo (y spam).');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <Logo size="large" showText={true} />
            <h1 className="auth-title">Restablecer contraseña</h1>
            <p className="auth-subtitle">
              {sent
                ? 'Si el correo existe, te enviaremos un enlace para restablecer tu contraseña.'
                : 'Ingresa tu correo y te enviaremos un enlace.'}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label className="form-label">Correo Electrónico</label>
              <div className="input-wrapper">
                <span className="input-icon-wrapper">
                  <FiMail className="input-icon" />
                </span>
                <input
                  type="email"
                  className="form-input"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar enlace'}
            </button>
          </form>

          <p className="auth-footer">
            <Link to="/login" className="link-primary">
              Volver a iniciar sesión
            </Link>
          </p>
        </div>

        <div className="auth-visual">
          <div className="visual-overlay"></div>
          <div className="visual-content">
            <h2>Recupera tu cuenta</h2>
            <p>Te enviaremos un enlace seguro para restablecer tu contraseña.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
